import { Component } from '@angular/core';
import { AccordionComponent } from "../../../project-stages/accordion/accordion.component";

@Component({
  selector: 'app-stage3navcall',
  standalone: true,
  imports: [AccordionComponent],
  templateUrl: './stage3navcall.component.html',
  styleUrl: './stage3navcall.component.css'
})
export class Stage3navcallComponent {

}
